import { Box, Typography, styled } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Carousel } from 'react-responsive-carousel'
import { useLocation } from 'react-router'
import { getInternalBanner } from '../../../../redux/actions/sliders'
import { IRootState } from '../../../../redux/types'
import SliderMoreInfo from '../../../frontoffice/sliders/ui/components/SliderMoreInfo'
import ReportButton from '../buttons/ReportButton'
import ResetButton from '../buttons/ResetButton'

const InternalBannerAdmin = styled('div')(({ theme }) => ({
  width: '100%',
  height: 64,
  backgroundColor: theme.palette.primary.main,
  display: 'flex',
  justifyContent: 'flex-end'
}))

const Img = styled('img')({
  maxWidth: '100%',
  height: '64px',
  objectFit: 'cover'
})

export default function InternalSlider({ detail, isHidden }: { detail?: boolean; isHidden?: boolean }) {
  const location = useLocation()
  const dispatch = useDispatch()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { internalbanner } = useSelector((state: IRootState) => state.slider)
  const { globalCountryId, globalLanguageId } = useSelector((state: IRootState) => state.global)
  const { commitFront } = useSelector((state: IRootState) => state.log)

  const [open, setOpen] = useState(false)
  const [sliderSelected, setSliderSelected] = useState({ id: null })

  useEffect(() => {
    if (authUser !== null) {
      dispatch(
        getInternalBanner({
          country_id: globalCountryId,
          language_id: globalLanguageId,
          internaltype: 3
        })
      )
    }
  }, [globalCountryId, globalLanguageId])

  const handleClickItem = (slider: any) => {
    if (slider.type === 0) {
      window.open(slider.value)
    } else if (slider.type === 1) {
      setOpen(!open)
      setSliderSelected(slider)
    }
  }

  let isAdmin = location.pathname.includes('admin') || location.pathname === '/escritorio' || location.pathname === '/usuarios/perfil'
  return (
    <Box>
      {isAdmin ? (
        <InternalBannerAdmin>
          <Box p={2} display="flex" alignItems="center">
            <Typography variant="caption" color="textSecondary">
              {commitFront}
            </Typography>
            <ResetButton admin />
            <ReportButton admin />
          </Box>
        </InternalBannerAdmin>
      ) : (
        <>
          {internalbanner.length === 0 ? (
            <Box
              sx={{ width: '100%', height: 64, bgcolor: 'primary.main' }}
              display={detail ? 'none' : isHidden && window.innerWidth < 959 ? 'none' : 'block'}
            />
          ) : (
            <Carousel autoPlay showThumbs={false} interval={7000} infiniteLoop>
              {internalbanner.map((banner: { id: number; image: string; title: string }) => (
                <Box key={banner.id} onClick={() => handleClickItem(banner)}>
                  <Img src={banner ? `${banner.image}?${Date.now()}` : ''} alt={banner.title} />
                </Box>
              ))}
            </Carousel>
          )}
        </>
      )}

      {sliderSelected.id !== null && <SliderMoreInfo slider={sliderSelected} open={open} setOpen={setOpen} />}
    </Box>
  )
}
